import {columnsTableRealObj as columnsTableRealObj_v1,subTitlesTableRealObj as subTitlesTableRealObj_v1} from './columns_REALOBJ';
import {columnsTableRealObj as columnsTableRealObj_v2,subTitlesTableRealObj as subTitlesTableRealObj_v2} from './columns_REALOBJ_v2';

export const columnsTableRealObj = (año, idVersion) => {
    switch (idVersion) {
        case 1:
            return columnsTableRealObj_v2(año);
        default: 
            return columnsTableRealObj_v1(año);
    }
}

export const subTitlesTableRealObj = (año, idVersion) => {
    switch (idVersion) {
        case 1:
            return subTitlesTableRealObj_v2(año);
        default: 
            return subTitlesTableRealObj_v1(año);
    }
}